import React, { Component } from 'react';
import OpenSeadragon from 'openseadragon';
/*import openseadragonruler from 'openseadragonruler';*/
import openseadragoncadess from 'openseadragoncadess';
import html2canvas from 'html2canvas';
import { connect } from 'react-redux';
import { updateOSGBounds, storeCurrentRotationAngleOfSpecimenImage } from '../../redux/actions';
import CadessHover from '../../assets/images/cadess_hover.png';
import CadessGrouphover from '../../assets/images/cadess_grouphover.png';
import CadessRest from '../../assets/images/cadess_rest.png';
import CadessPressed from '../../assets/images/cadess_pressed.png';
/*import RulerHover from '../../assets/images/ruler_hover.png';
import RulerGrouphover from '../../assets/images/ruler_grouphover.png';
import RulerRest from '../../assets/images/ruler_rest.png';
import RulerPressed from '../../assets/images/ruler_pressed.png';
import RulerCancelHover from '../../assets/images/selection_cancel_hover.png';
import RulerCancelGrouphover from '../../assets/images/selection_cancel_grouphover.png';
import RulerCancelRest from '../../assets/images/selection_cancel_rest.png';
import RulerCancelPressed from '../../assets/images/selection_cancel_pressed.png';*/

class CaseSpecimenOpenSeadragon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewer: {},
      initialViewerValues: {
        id: 'specimen',
        prefixUrl: 'https://openseadragon.github.io/openseadragon/images/',
        crossOriginPolicy: 'Anonymous',
        tileSources: this.props.imgUrl,
        showNavigator: true,
        showRotationControl: true,
        autoHideControls: false, // For both toolbar and navigation window
        degrees: this.props.imageRotation || 0,
        navigatorPosition: 'BOTTOM_LEFT',
        navigatorBackground: 'white',
        blendTime: 0.2,
        maxImageCacheCount: 100,
        animationTime: 0.5,
        constrainDuringPan: false,
        maxZoomPixelRatio: 1,
        minZoomPixelRatio: 1,
        visibilityRatio: 0.0,
        zoomPerScroll: 2,
        timeout: 100000,
        immediateRender: true,
        imageLoaderLimit: 3,
      },
    };
  }

  componentDidMount() {
    const { imageBounds, cadessOverlayIsVisible, cadessStatus, mpp } = this.props;
    const viewer = OpenSeadragon(this.state.initialViewerValues);
    
    this.addChangesOfViewportHandler(viewer);
    this.addRotationHandlerToViewer(viewer);

    if (imageBounds) {
      viewer.addOnceHandler('tile-loaded', (event) => {
        const { userData: bounds } = event;
        viewer.viewport.fitBounds(bounds, true);
      }, imageBounds, 1);
    }

    //this.addRuler(viewer, mpp);
    this.applyCadessOverlay(viewer, cadessOverlayIsVisible, cadessStatus);
    this.updateViewerInLocalState(viewer);
  }

  componentDidUpdate(prevProps) {                                                                          
    const { cadessOverlayIsVisible, cadessImgUrl, cadessStatus, mpp } = this.props;
    console.log("componentDidUpdate", cadessOverlayIsVisible, cadessImgUrl, cadessStatus, mpp);
    if (!cadessImgUrl) {
      return null;
    }
    //if (mpp !== prevProps.mpp) {
      //this.addRuler(this.state.viewer, mpp);
    //}
    if (cadessImgUrl !== prevProps.cadessImgUrl || cadessStatus !== prevProps.cadessStatus) {
      //this.addRuler(this.state.viewer, mpp);
      this.applyCadessOverlay(this.state.viewer, cadessOverlayIsVisible, cadessStatus);
    }
    if (cadessOverlayIsVisible !== prevProps.cadessOverlayIsVisible) {
      const opacity = cadessOverlayIsVisible ? 1 : 0;
      return this.state.viewer.world.getItemAt(1).setOpacity(opacity);
    }
    return null;
  }

  componentWillUnmount() {
    this.state.viewer.destroy();
  }

  updateViewerInLocalState = (viewer) => this.setState({ viewer })

  handleSnapShot = () => {
    if (this.element) {
      html2canvas(this.element).then((canvas) => {
        const base64Image = canvas.toDataURL('image/png').substring(15);
        const snapShot = {
          id: Math.random() * 100,
          data: base64Image,
        };
        this.props.handleTempSnapshot(snapShot);
      });
    } else {
      this.props.cancelSnapshot();
    }
  };

  /*
  addRuler(viewer, mpp) {
    console.log("Adding MPP", mpp);
    if (!mpp) {
      return;
    }
    viewer.ruler({
      element:                 null, // html element to use for overlay
      showSelectionControl:    true, // show button to toggle selection mode
      toggleButton:            null, // dom element to use as toggle button
      showConfirmDenyButtons:  true,
      styleConfirmDenyButtons: true,
      returnPixelCoordinates:  true,
      keyboardShortcut:        'r', // key to toggle selection mode
      rect:                    null, // initial selection as an OpenSeadragon.SelectionRect object
      restrictToImage:         true, // true = do not allow any part of the selection to be outside the image
      onSelection:             function(rect) {}, // callback
      prefixUrl:               " ", // overwrites OpenSeadragon's option
      cornersStyle: {
          width:      '10px',
          height:     '10px',
          background: '#000',
          border:     '1px solid #ccc'
      },
      navImages:               { // overwrites OpenSeadragon's options
        selection: {
            REST:   RulerRest,
            GROUP:  RulerGrouphover,
            HOVER:  RulerHover,
            DOWN:   RulerPressed
        },
        selectionCancel: {
            REST:   RulerCancelRest,
            GROUP:  RulerCancelGrouphover,
            HOVER:  RulerCancelHover,
            DOWN:  RulerCancelPressed
        },
    },
      pixelsPerMeter: mpp ? (1e6 / mpp) : 0,
    });
  }
  */

  applyCadessOverlay(viewer, overlayShouldBeVisible, cadessStatus) {
    if (cadessStatus && cadessStatus !== 'N/A') {
      viewer.cadessoverlay({
        keyboardShortcut:        'c', // key to toggle selection mode
        prefixUrl:               " ", // overwrites OpenSeadragon's option
        navImages:               { // overwrites OpenSeadragon's options
          selection: {
              REST:   CadessRest,
              GROUP:  CadessGrouphover,
              HOVER:  CadessHover,
              DOWN:   CadessPressed
          }
        },
        tileSource: this.props.cadessImgUrl,
        isOn: overlayShouldBeVisible
      });
    }
    /*if (cadessStatus && cadessStatus !== 'N/A') {
      viewer.addTiledImage({
        tileSource: this.props.cadessImgUrl,
        x: 0,
        y: 0,
        width: 1,
        opacity: overlayShouldBeVisible ? 1 : 0,
      });
    }*/
  }

  addRotationHandlerToViewer(viewer) {
    viewer.addHandler(
      'rotate', (event) => {
        const { degrees, userData: specimenId } = event;
        this.props.storeCurrentRotationAngleOfSpecimenImage(degrees, specimenId);
      },
      this.props.specimenId,
    );
  }

  addChangesOfViewportHandler(viewer) {
    viewer.addHandler('viewport-change', (event) => {
      const { userData: viewer } = event;
      this.props.updateOSGBounds(
        this.props.specimenId,
        viewer.viewport.getBounds(),
      );
    }, viewer);
  }

  render() {
    if (this.props.snapshotActive) {
      this.handleSnapShot();
    }

    return (
      <div className="openseadragon-container-2">
        <div
          id="specimen"
          ref={ref => {
            this.element = ref;
          }}
        />
      </div>
    );
  }
}

export default connect(
  null,
  {
    updateOSGBounds,
    storeCurrentRotationAngleOfSpecimenImage,
  },
)(CaseSpecimenOpenSeadragon);
